<section class="title-container text-center">
  <h1 class="club-name">ŠPORTNO DRUŠTVO HOTEDRŠICA</h1>

  <!-- Use a grid to perfectly center the logo and balance button widths -->
  <div class="d-grid align-items-center mt-4" style="grid-template-columns: 1fr auto 1fr; gap: 1.5rem;">
    
    <!-- Left Buttons (Right-Aligned) -->
    <div class="d-flex flex-column align-items-end">
      <button class="button-74 skrij-tablet mb-2" (click)="scrollTo('news')">Novice</button>
      <button class="button-74 skrij-tablet" (click)="scrollTo('donations')">Doniraj</button>
    </div>

    <!-- Logo Centered in Middle Column -->
    <div class="sd-logo d-flex justify-content-center">
      <img src="/assets/images/organisations/sports/logo.png" alt="Club Logo" class="img-fluid logo-img">
    </div>

    <!-- Right Buttons (Left-Aligned) -->
    <div class="d-flex flex-column align-items-start skrij-tablet">
      <button *ngIf="hot100Exists" class="button-prijava-heading neon-yellow mb-2" (click)="scrollTo('hot100')">HOT 100</button>
      <button *ngIf="tekPrijatelstvaExists" class="button-prijava-heading neon-green mb-2" (click)="scrollTo('tek-prijateljstva')">TEK PRIJATELJSTVA</button>
      <button *ngIf="varstvoExists" class="button-prijava-heading neon-blue mb-2" (click)="scrollTo('varstvo')">HOTENJSKI ŠPORTNI TEDEN</button>
      <button *ngIf="cold50Exists" class="button-prijava-heading neon-navy" (click)="scrollTo('cold50')">COLD 50</button>
    </div>

    <!-- Mobile-only buttons: direct child of .d-grid, so grid-row/grid-column in CSS actually work -->
    <div class="mobile-event-buttons">
      <button *ngIf="hot100Exists" class="button-prijava-heading-mobile neon-yellow" (click)="scrollTo('hot100')">HOT 100</button>
      <button *ngIf="tekPrijatelstvaExists" class="button-prijava-heading-mobile neon-green" (click)="scrollTo('tek-prijateljstva')">TEK PRIJATELJSTVA</button>
    </div>

  </div>
</section>

<section id="navbar">
  <div id="orgBar" class="container-fluid">
    <button id="burger" (click)="toggleMenu()">☰</button>
    <div id="menu" [ngClass]="{ 'show': menuOpen }">
      <button class="org-button" (click)="scrollTo('introduction')">Kdo smo</button>
      <button class="org-button" (click)="scrollTo('news')">Novice</button>
      <button class="org-button" (click)="scrollTo('exercises')">Vadbe</button>
      <button class="org-button" (click)="scrollTo('events')">Dogodki</button>
      <button class="org-button" (click)="scrollTo('gallery-section')">Utrinki</button>
      <button *ngIf="tekPrijatelstvaExists" class="org-button" (click)="scrollTo('tek-prijateljstva')">Tek prijateljstva</button>
      <button *ngIf="hot100Exists" class="org-button" (click)="scrollTo('hot100')">HOT 100</button>
      <button *ngIf="varstvoExists" class="org-button" (click)="scrollTo('varstvo')">Športni teden</button>
      <button *ngIf="cold50Exists" class="org-button" (click)="scrollTo('cold50')">COLD 50</button>
      <button class="org-button" (click)="scrollTo('proge')">Proge</button>
      <button class="org-button" (click)="scrollTo('van-rental')">Najem kombija</button>
      <button class="org-button" (click)="scrollTo('donations')">Doniraj</button>
      <button class="org-button" (click)="scrollTo('club-details')">Vizitka</button>
      <!--<button class="org-button" (click)="scrollTo('sponsors')">Sponzorji</button>-->
    </div>
  </div>
</section>

  <section id="introduction" class="history-container container">
    <h1 class="club-name animated-title mb-5">KDO SMO</h1>
    <p class="animated-text fs-6">Športno društvo Hotedršica, ustanovljeno leta 1997, s sedežem V Hotedršici, združuje ljubitelje teka, teka na smučeh, pohodništva, kolesarstva, nogometa in različnih vadb, ki želijo preko športa izboljšati svoje fizične sposobnosti, spoznati nove prijatelje in prispevati k lokalni skupnosti. V društvu skrbimo za širjenje kulture športa na širšem območju našega delovanja.</p>
    <p class="animated-text fs-6">Od svoje ustanovitve je Športno društvo Hotedršica zraslo iz majhne skupine entuziastov v priznano športno organizacijo z več kot 100 člani. V dosedanji zgodovini se lahko pohvalimo z različnimi odličnimi rezultati naših članov na različnih športnih tekmovanjih. Leta 2021 je društvo prvič zmagalo v ekipni razvrstitvi Primorskih pokalnih tekov za vse generacije.</p>
    <p class="animated-text fs-6">Vizija društva je širiti ponudbo športnih aktivnosti, nuditi kakovostno vadbo ter cenovno dostopne športne izlete za vse člane. Skrbimo za redne aktivnosti najmlajših (Mucek se giba), treningi osnovno šolskih otrok (tekaška sekcija), vadbe za člane društva (vadba pilatesa, vadba za ta mlade, vadba za starejše, funkcionalna vadba), ter nogometna, pohodniška in kolesarska sekcija. Poleg vseh rednih treningov, vadb in ostalih aktivnosti društvo skrbi, da vsako leto organizira enega najbolj tradicionalnih tekov v Sloveniji – Tek prijateljstva (leta 2024 že 53. po vrsti), nogometne turnirje, enodnevne izlete za člane, ter ostale športne dogodke. V primeru dobrih zim poskrbimo tudi za smučarsko- tekaške proge v okolici Hotedršice.</p>
  </section>
  
  <section id="club-image" class="mb-5 container">
    <div class="row">
        <div class="col-12 col-md-6 d-flex align-items-center justify-content-center">
            <img src="/assets/images/organisations/sports/sdOzadje.jpg" 
                alt="Sports Club Image" 
                class="img-fluid animated-image left-image">
        </div>
        <div class="col-12 col-md-6 d-flex align-items-center justify-content-center">
            <img src="/assets/images/organisations/sports/razgled.jpg" 
                alt="Sports Club Image" 
                class="img-fluid animated-text">
        </div>
    </div>
  </section>

<!--<div class="container">
  <app-sliding-background
  [images]="['/assets/images/organisations/sports/7.jpg', '/assets/images/organisations/sports/vodstvo.jpg', '/assets/images/organisations/sports/4.jpg', '/assets/images/organisations/sports/5.jpg']"
  [speed]="12"
  [width]="'100%'"
  [height]="'100vh'"
  [borderRadius]="'15px'"
  [overlay]="'rgba(0, 0, 0, 0.3)'">
</app-sliding-background>
</div>-->

  <div class="curvy-container">
    </div>
  <!-- News Section -->
  <section id="news" class="p-1 pt-5">
    <h1 class="club-name animated-title">NOVICE</h1>
    <app-news-list 
    [organisation]="organisation" 
    [isSuperAdmin]="isSuperAdmin" 
    [isOrgAdmin]="isOrgAdmin" 
    [news]="news"
    [totalNewsCount]="totalItems"
    (loadMoreClicked)="loadMoreNews()"
    (newsChanged)="handleNewsChanged()"
    ></app-news-list>
  </section>
  <div class="curvy-container-inv-color">
  </div>

<!-- Exercises Section -->
<section id="exercises" class="anchor-section">
  <h1 class="club-name animated-title">VADBE</h1>

  <div class="exercise-cards container p-1 pt-5">
    <div class="exercise-card-wrapper" *ngFor="let exercise of exercises">
      <div class="exercise-card d-flex justify-content-center animated-text" (click)="openExerciseModal(exercise)">
        <img [src]="exercise.imageUrl" alt="{{ exercise.name }}" />
        <div class="exercise-name">
          <h3>{{ exercise.name }}</h3>
        </div>
      </div>
      
      <div class="d-flex justify-content-center mt-2">
        <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn btn-primary me-2"
                (click)="editExercise(exercise)">
          Uredi vadbo
        </button>
        <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn btn-danger"
                (click)="deleteExercise(exercise.exerciseID)">
          Izbriši vadbo
        </button>
      </div>
    </div>
  </div>
  

  <!-- Show add button for admins -->
  <div *ngIf="isOrgAdmin || isSuperAdmin" class="d-flex justify-content-center mt-3">
    <button class="btn btn-success" (click)="showAddExerciseForm = !showAddExerciseForm">
      {{ showAddExerciseForm ? 'Skrij obrazec' : 'Dodaj novo vadbo' }}
    </button>
  </div>

  <!-- Add Exercise Form (Toggles visibility) -->
  <div *ngIf="showAddExerciseForm" class="container mt-4">
    <form (submit)="saveExercise()" enctype="multipart/form-data" class="p-3 border rounded shadow bg-light">
      <div class="form-group">
        <label for="exerciseName">Ime vadbe</label>
        <input 
          type="text" 
          id="exerciseName" 
          class="form-control" 
          [(ngModel)]="newExercise.name" 
          name="name" 
          required 
          placeholder="Vnesite ime vadbe" />
      </div>

      <div class="form-group">
        <label for="exerciseDescription">Opis vadbe</label>
        <textarea 
          id="exerciseDescription" 
          class="form-control" 
          [(ngModel)]="newExercise.description" 
          name="description" 
          required 
          placeholder="Vnesite opis vadbe">
        </textarea>
      </div>

      <div class="form-group">
        <label for="exerciseSchedule">Termin vadbe</label>
        <input 
          type="text" 
          id="exerciseSchedule" 
          class="form-control" 
          [(ngModel)]="newExercise.schedule" 
          name="schedule" 
          placeholder="Vnesite termin vadbe" />
      </div>

      <div class="form-group">
        <label for="exerciseCost">Cena vadbe</label>
        <input 
          type="text" 
          id="exerciseCost" 
          class="form-control" 
          [(ngModel)]="newExercise.cost" 
          name="cost" 
          placeholder="Vnesite ceno vadbe" />
      </div>

      <div class="form-group">
        <label for="exerciseLeader">Vodja vadbe</label>
        <input 
          type="text" 
          id="exerciseLeader" 
          class="form-control" 
          [(ngModel)]="newExercise.leader" 
          name="leader" 
          placeholder="Vnesite ime vodje vadbe" />
      </div>

      <div class="form-group">
        <label for="leaderPhone">Telefon vodje</label>
        <input 
          type="text" 
          id="leaderPhone" 
          class="form-control" 
          [(ngModel)]="newExercise.leaderPhone" 
          name="leaderPhone" 
          placeholder="Vnesite telefonsko številko" />
      </div>

      <div class="form-group">
        <label for="trainers">Trenerji (ločeni z vejico)</label>
        <input 
          type="text" 
          id="trainers" 
          class="form-control" 
          [(ngModel)]="newExercise.trainers" 
          name="trainers" 
          placeholder="Vnesite imena trenerjev" />
      </div>

      <div class="form-group">
        <label for="exerciseImage">Naloži sliko vadbe</label>
        <input 
          type="file" 
          id="exerciseImage" 
          class="form-control-file" 
          (change)="onImageUploadChanged($event)" 
          accept="image/png, image/jpeg" />

        <div *ngIf="previewImageSrc" class="image-preview mt-2 text-center">
          <p>Predogled slike:</p>
          <img [src]="previewImageSrc" alt="Predogled slike" class="img-thumbnail preview-img" />
        </div>
      </div>
      <div>
        <button type="submit" class="btn btn-primary">{{ isEditExerciseMode ? 'Posodobi' : 'Shrani' }}</button>
      </div>
    </form>  
  </div>
</section>


  <div class="curvy-container-color"></div>

  <!-- Events Section -->
  <section *ngIf="organisationId" id="events" class="anchor-section">
    <h1 class="font-weight-bold club-name animated-title">DOGODKI</h1>
    <div class="container mt-5">
    <app-event-list [allEvents]="allEvents"
     [onOrganisationPage]="true"
     [isOrgAdmin]="isOrgAdmin" 
     [isSuperAdmin]="isSuperAdmin"
     [organisationID]="organisationId"
     (eventChanged)="handleEventAdded()"
     ></app-event-list>
  </div>
  </section>

  <section id="gallery-section" class="anchor-section">
    <h1 class="font-weight-bold club-name animated-title">UTRINKI</h1>
    <div class="container p-2">
    <gallery class="w-100" id="gallery" [objectFit]="'contain'" [loop]="true" [items]="sportsImages" (thumbClick)="onThumbClick($event)"></gallery>
    <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn button-74 mt-3" (click)="openAddSportsImagesModal()">
      <fa-icon class="fa-lg me-2" [icon]="faPlus"></fa-icon>Dodaj slike</button>
    <button *ngIf="imageSelected && (isOrgAdmin || isSuperAdmin)" (click)="deleteSelectedImage()" class="btn button-74 mt-3">
      <fa-icon class="fa-lg me-2" [icon]="faTrash"></fa-icon>Izbriši izbrano sliko
  </button>
  </div>
  </section>

  <div *ngIf="!cold50Exists || hot100Exists || tekPrijatelstvaExists || varstvoExists" class="curvy-container-inv-color-blue"></div>

  <section *ngIf="tekPrijatelstvaExists" id="tek-prijateljstva" class="p-2 anchor-section">
    <div class="text-center mt-5 p-2 animated-image left-image">
      <img src="../../../assets/images/organisations/sports/tek-logo.png" alt="Tek prijateljstva" class="img-fluid">
    </div>
    <h1 class="mt-4 fw-bold text-center animated-title responsive-title" style="color: gold;">Hotedršica {{ tekPrijateljstvaDate | date:'dd.MM.yyyy' }}</h1>   
    <div class="container mt-5">

        <!-- Row 1: Otroci -->
        <div class="row g-4 align-items-center" style="border-bottom: white 1px solid; border-top: white 1px solid; padding-bottom: 3rem;">
          <!-- Left Column: Vertical Title -->
          <div class="col-md-4 d-flex flex-column align-items-center">
            <h1 class="club-name-neon neon-green animated-title">Otroci</h1>
            <img src="../../../assets/images/organisations/sports/tek-otroci.jpg" class="blob-image animated-image left-image neon-green" alt="Club Image">
            <!--<div class="d-flex align-items-center justify-content-center animated-title">
              <button class="button-prijava neon-green" (click)="onTekPrijavaClicked(); scrollTo('tek-prijatelstva-prijava')">PRIJAVA</button>
            </div>-->
          </div>
          <!-- Middle Column: Circles -->
          <div class="col-md-2 text-center animated-title mb-5">
            <div class="d-flex flex-column align-items-center gap-4">
              <div class="circle neon-green text-white p-4">
                <fa-icon class="fa-md" [icon]="faRocket"></fa-icon>
                <p>14:00</p>
              </div>
              <div class="circle neon-green text-white p-4">
                <fa-icon class="fa-md" [icon]="faRuler"></fa-icon>
                <p>200 - 2000 m</p>
              </div>
              <div class="circle neon-green text-white p-4">
                <fa-icon class="fa-md" [icon]="faGift"></fa-icon>
                <p>Darilo</p>
              </div>
            </div>
          </div>
            <!-- Right Column: Text and Stuff -->
          <div class="col-md-5 event-description-tek mt-2 animated-text">
            <ul>
              <li>Štart šolske in predšolske mladine je ob <strong class="neon-green">14h</strong>.</li>
              <li>CICI TEK (250m) za predšolske otroke je <strong class="neon-green">netekmovalen</strong>.</li>
              <li>Vsi tekmovalci sodelujejo pri <strong class="neon-green">žrebanju</strong> praktičnih nagrad.</li>
              <li>Na cilju vsi otroci prejmejo <strong class="neon-green">spominsko medaljo, bon za prehrano ter darilo</strong>.</li>
              <li>Prvi trije v ženski in moški konkurenci skupno dobijo medalje.</li>
              <li>Pri kategoriziranju upoštevamo letnico rojstva.</li>
              <li><strong class="neon-green">Štartnina: 2€</strong>.</li>
              <li>Tečemo v vsakem vremenu.</li>
              <li>Vsi tekmovalci tečejo na lastno odgovornost.</li>
              <li>
                <a [routerLink]="[]" fragment="children-cathegory" style="color: white;">
                  <strong class="neon-green">Kategorije in ogled proge</strong>
                </a>
              </li>              
            </ul>
          </div>
        </div>
      
        <!-- Row 2: Rekreativni tek -->
        <div class="row g-4 align-items-center mt-3" style="border-bottom: white 1px solid; padding-bottom: 3rem;">
          <!-- Left Column: Vertical Title -->
            <div class="col-md-4 d-flex flex-column align-items-center">
            <h2 class="club-name-neon neon-purple animated-title text-center text-truncate" style="max-width: 100%;">
              Rekreativni tek
            </h2>
            <img src="../../../assets/images/organisations/sports/2.jpg" class="blob-image animated-image left-image neon-purple" alt="Club Image">
            <!--<div class="d-flex align-items-center justify-content-center animated-title">
              <button class="button-prijava neon-purple" (click)="onTekPrijavaClicked(); scrollTo('tek-prijatelstva-prijava')">PRIJAVA</button>
            </div>-->
            </div>
          <!-- Middle Column: Circles -->
          <div class="col-md-2 text-center animated-title mb-5">
            <div class="d-flex flex-column align-items-center gap-4">
              <div class="circle neon-purple text-white p-4">
                <fa-icon class="fa-md" [icon]="faRocket"></fa-icon>
                <p>16:55</p>
              </div>
              <div class="circle neon-purple text-white p-4">
                <fa-icon class="fa-md" [icon]="faRuler"></fa-icon>
                <p>4.8 km</p>
              </div>
              <div class="circle neon-purple text-white p-4">
                <fa-icon class="fa-md" [icon]="faGift"></fa-icon>
                <p>Darilo</p>
              </div>
            </div>
          </div>
            <!-- Right Column: Text and Stuff -->
            <div class="col-md-5 event-description-tek mt-2 animated-text">
              <ul>
                <li>Štart rekreativnega teka je ob <strong class="neon-purple">16:55</strong>.</li>
                <li>Dolžina proge je <strong class="neon-purple">4.8km</strong>.</li>
                <li>Vsi tekmovalci sodelujejo pri <strong class="neon-purple">žrebanju</strong> praktičnih nagrad.</li>
                <li>Na cilju vsi tekmovalci prejmejo <strong class="neon-purple">spominsko medaljo, bon za prehrano ter darilo</strong>.</li>
                <li>Prvi trije v ženski in moški konkurenci v vsakem letniku dobijo pokale.</li>
                <li>Prvi trije v ženski in moški konkurenci v kategorijah dobijo medalje.</li>
                <li>Pri kategoriziranju upoštevamo letnico rojstva.</li>
                <li><strong class="neon-purple">Štartnina 10€</strong>.</li>
                <li>Tečemo v vsakem vremenu.</li>
                <li>Vsi tekmovalci tečejo na lastno odgovornost.</li>
                <li>
                  <a [routerLink]="[]" fragment="recreational-cathegory" style="color: white;">
                    <strong class="neon-purple">Kategorije in ogled proge</strong>
                  </a>
                </li>
              </ul>
            </div>
        </div>
      
        <!-- Row 3: Člani -->
        <div class="row g-4 align-items-center mt-3 pb-5" style="border-bottom: white 1px solid;">
          <!-- Left Column: Vertical Title -->
          <div class="col-md-4 d-flex flex-column align-items-center">
            <h2 class="club-name-neon neon-red animated-title">Člani</h2>
            <img src="../../../assets/images/organisations/sports/1.jpg" class="blob-image animated-image left-image neon-red" alt="Club Image">
            <!--<div class="d-flex align-items-center justify-content-center">
              <button class="button-prijava neon-red animated-title" (click)="onTekPrijavaClicked(); scrollTo('tek-prijatelstva-prijava')">PRIJAVA</button>
            </div>-->
          </div>
          <!-- Middle Column: Circles -->
          <div class="col-md-2 text-center animated-title mb-5">
            <div class="d-flex flex-column align-items-center gap-4">
              <div class="circle neon-red text-white p-4">
                <fa-icon class="fa-md" [icon]="faRocket"></fa-icon>
                <p>17:00</p>
              </div>
              <div class="circle neon-red text-white p-4">
                <fa-icon class="fa-md" [icon]="faRuler"></fa-icon>
                <p>11.8 km</p>
              </div>
              <div class="circle neon-red text-white p-4">
                <fa-icon class="fa-md" [icon]="faGift"></fa-icon>
                <p>Darilo</p>
              </div>
            </div>
          </div>
          <!-- Right Column: Text and Stuff -->
          <div class="col-md-5 event-description-tek mt-2 animated-text">
            <ul>
              <li>Štart teka za člane je ob <strong class="neon-red">17h</strong>.</li>
              <li>Dolžina proge je <strong class="neon-red">11.8 km</strong>.</li>
              <li>Vsi tekmovalci sodelujejo pri <strong class="neon-red">žrebanju</strong> praktičnih nagrad.</li>
              <li>Na cilju vsi tekmovalci prejmejo <strong class="neon-red">spominsko medaljo, bon za prehrano ter darilo</strong>.</li>
              <li>Prvi trije v ženski in moški konkurenci skupno dobijo pokale.</li>
              <li>Prvi trije v ženski in moški konkurenci v kategorijah dobijo medalje.</li>
              <li>Pri kategoriziranju upoštevamo letnico rojstva.</li>
              <li><strong class="neon-red">Štartnina 10€</strong>.</li>
              <li>Tečemo v vsakem vremenu.</li>
              <li>Vsi tekmovalci tečejo na lastno odgovornost.</li>
                <li>Kategorije in ogled proge: 
                <a [routerLink]="[]" fragment="men-table" style="color: white; display: inline-block;"><strong class="neon-red">Moški</strong></a>
                <a [routerLink]="[]" fragment="women-table" style="color: white; display: inline-block; margin-left: 10px;"><strong class="neon-red">Ženske</strong></a>
                </li>
            </ul>
          </div>
        </div>
      </div>

    
  <div id="cathegory-tables" class="mt-5">
  <!-- Children's table -->
  <h2 class="club-name-neon neon-green animated-title" style="font-size: 2rem;">Kategorije šolske mladine</h2>
  <div id="children-cathegory" class="table-responsive animated-title">
    <table class="table table-striped table-bordered text-center mt-4">
      <thead>
        <tr>
          <th>Kategorija</th>
          <th>Letnik</th>
          <th>Starost</th>
          <th>Dolžina</th>
          <th>Trasa</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let category of childrenCategories">
          <td>{{ category.name }}</td>
          <td>{{ getEligibleYearsForChildren(category) }}</td>
          <td>{{ category.minAge === 0 ? '< ' + category.maxAge : (category.minAge === category.maxAge ? category.minAge : (category.minAge + ' - ' + category.maxAge)) }}</td>
          <td>{{ category.distance }}</td>
          <td>
            <a [href]="category.link" target="_blank" class="btn btn-link">Preglej progo</a>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="text-center event-description-tek mt-3">
      Pri razvrstitvi v starostne kategorije se upošteva letnica rojstva in ne datum rojstva!
    </div>
  </div>
    <!-- Recreational table -->
    <h2 class="club-name-neon neon-purple animated-title mt-5" style="font-size: 2rem;">Kategorije za rekreativni tek</h2>
    <div id="recreational-cathegory" class="table-responsive animated-title">
      <table class="table table-striped table-bordered text-center mt-4">
        <thead>
          <tr>
            <th>Kategorija</th>
            <th>Letnik</th>
            <th>Starost</th>
            <th>Dolžina</th>
            <th>Trasa</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let category of recreationalCategories">
            <td>{{ category.name }}</td>
            <td>{{ getEligibleYearsForRecreational(category) }}</td>
            <td>{{ category.maxAge === 100 ? category.minAge + ' <' : (category.minAge === 0 ? '< ' + category.maxAge : (category.minAge === category.maxAge ? category.minAge : (category.minAge + ' - ' + category.maxAge))) }}</td>
            <td>{{ category.distance }}</td>
            <td>
              <a [href]="category.link" target="_blank" class="btn btn-link">Preglej progo</a>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-center event-description-tek mt-3">
        Pri razvrstitvi v starostne kategorije se upošteva letnica rojstva in ne datum rojstva!
      </div>
    </div>

        <!-- Grownups (Men) table -->
    <h2 class="club-name-neon neon-red animated-title mt-5" style="font-size: 2rem;">Kategorije za člane</h2>
    <div id="men-table" class="table-responsive animated-title">
      <table class="table table-striped table-bordered text-center mt-4">
        <thead>
          <tr>
            <th>Kategorija</th>
            <th>Letnik</th>
            <th>Starost</th>
            <th>Dolžina</th>
            <th>Trasa</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let category of grownupsMenCategories">
            <td>{{ category.name }}</td>
            <td>{{ getEligibleYearsForGrownups(category) }}</td>
            <td>{{ category.maxAge === 100 ? category.minAge + ' <' : (category.minAge === 0 ? '< ' + category.maxAge : (category.minAge === category.maxAge ? category.minAge : (category.minAge + ' - ' + category.maxAge))) }}</td>
            <td>{{ category.distance }}</td>
            <td>
              <a [href]="category.link" target="_blank" class="btn btn-link">Preglej progo</a>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-center event-description-tek mt-3">
        Pri razvrstitvi v starostne kategorije se upošteva letnica rojstva in ne datum rojstva!
      </div>
    </div>

    <!-- Grownups (Women) table -->
    <h2 class="club-name-neon neon-red animated-title mt-5" style="font-size: 2rem;">Kategorije za članice</h2>
    <div id="women-table" class="table-responsive animated-title">
      <table class="table table-striped table-bordered text-center mt-4">
        <thead>
          <tr>
            <th>Kategorija</th>
            <th>Letnik</th>
            <th>Starost</th>
            <th>Dolžina</th>
            <th>Trasa</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let category of grownupsWomenCategories">
            <td>{{ category.name }}</td>
            <td>{{ getEligibleYearsForGrownups(category) }}</td>
            <td>{{ category.maxAge === 100 ? category.minAge + ' <' : (category.minAge === 0 ? '< ' + category.maxAge : (category.minAge === category.maxAge ? category.minAge : (category.minAge + ' - ' + category.maxAge))) }}</td>
            <td>{{ category.distance }}</td>
            <td>
              <a [href]="category.link" target="_blank" class="btn btn-link">Preglej progo</a>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-center event-description-tek mt-3">
        Pri razvrstitvi v starostne kategorije se upošteva letnica rojstva in ne datum rojstva!
      </div>
    </div>
  </div>

    <section *ngIf="showTekPrijava" id="tek-prijatelstva-prijava" class="mt-5">
      <div>
        <app-friendship-race-prijava [isOrgAdmin]="isOrgAdmin"></app-friendship-race-prijava>
    </div>
    <div class="d-flex align-items-center justify-content-center mt-3" *ngIf="showTekPrijava">
      <button class="button-prijava neon-red" (click)="OnTekZapriClicked(); scrollTo('tek-prijateljstva')">Zapri</button>
    </div>
  </section>
</section>

  <section *ngIf="hot100Exists" id="hot100" class="anchor-section">
    <div class="d-flex justify-content-center">
      <img src="../../../assets/images/organisations/sports/hot100logo.png" alt="Hot100 Image" class="img-fluid">
    </div>
  
    <!-- Big Title -->
    <h1 class="mt-4 fw-bold text-center" style="color: white;">Hotedršica {{ hot100date | date:'dd.MM.yyyy' }}</h1>
  
    <!-- Info Circles -->
    <div class="d-flex justify-content-center flex-wrap gap-4 mt-4 text-center">
      <div class="circle neon-red text-white p-4 mb-3">
        <fa-icon class="fa-2x" [icon]="faRocket"></fa-icon>
        <p class="font-size-1.5">6:00</p>
      </div>
      <div class="circle neon-purple text-white p-4 mb-3">
        <fa-icon class="fa-2x" [icon]="faFlagCheckered"></fa-icon>
        <p>20:00</p>
      </div>
      <div class="circle neon-blue text-white p-4 mb-3">
        <fa-icon class="fa-2x" [icon]="faRuler"></fa-icon>
        <p>6,7 km</p>
      </div>
      <div class="circle neon-green text-white p-4 mb-3">
        <fa-icon class="fa-2x" [icon]="faMountain"></fa-icon>
        <!--<h5 class="mt-5">VIŠINSKIH METROV</h5>-->
        <p>165 m</p>
      </div>
      <div class="circle neon-yellow text-white p-4 mb-3">
        <fa-icon class="fa-2x" [icon]="faPersonRunning"></fa-icon>
        <p>100 km</p>
      </div>
    </div>
  
    <!-- Event Description and Button in the Same Row -->
    <div class="d-flex container justify-content-start align-items-center mt-5 flex-wrap">
    <div class="event-description text-light">
      <h2 class="text-warning p-4 text-center"> O dogodku</h2>
      <div class="row">
        <div class="col-md-10">
        <ul class="list-unstyled">
          <li> <strong>Postavite si svoj cilj</strong> in ga poskušajte doseči!</li>
          <li> Vsak tekmovalec preteče <strong>želeno število krogov</strong>.</li>
          <li> Cilj je preteči 6,7 km krog <strong>v manj kot 60 minutah</strong>.</li>
          <li> Štarti so <strong>vsako polno uro</strong> med <strong>6:00 in 20:00</strong>.</li>
          <li> <strong>15 zaporednih krogov</strong> pomeni, da ste dosegli 100 km!</li>
          <li> Prihod v cilj = <strong>prejmete darilo</strong>!</li>
          <li> Medaljo si sestavite <strong>kar sami</strong> na prireditvi.</li>
          <li> Na voljo so <strong>ogrevani prostori</strong>, sanitarije in okrepčevalnica.</li>
          <li> Udeležba je <strong>BREZPLAČNA</strong>!</li>
        </ul>
      </div>
      <div class="col-md-2 d-flex align-items-center justify-content-center">
        <button class="button-prijava neon-yellow" (click)="onPrijavaClicked(); scrollTo('hot100-prijava')">PRIJAVA</button>
      </div>
    </div>
    </div>
    </div>
    <div class="container">
      <div class="row d-flex flex-wrap">
        <!-- Map -->
        <div class="col-12 col-md-6 mb-4 mb-md-0">
          <app-map [onSportsPage]="true" [interactive]="false"></app-map>
        </div>
        
        <!-- Gallery -->
        <div class="col-12 col-md-6">
          <gallery class="w-100" id="gallery" [objectFit]="'contain'" [loop]="true" [items]="hot100Images" (thumbClick)="onThumbClick($event)"></gallery>
        </div>
      </div>
    </div>
    
  </section>

 <section id="hot100-prijava" class="mt-5">
    <div *ngIf="showHot100prijava">
      <app-hot100-prijava [isOrgAdmin]="isOrgAdmin"></app-hot100-prijava>
  </div>
  <div class="d-flex align-items-center justify-content-center mt-3" *ngIf="showHot100prijava">
    <button class="button-prijava neon-red" (click)="OnZapriClicked(); scrollTo('hot100')">Zapri</button>
  </div>
 </section>
 
 <section *ngIf="varstvoExists" id="varstvo" class="container pt-5 anchor-section">
  <div class="d-flex justify-content-center">
    <img src="../../../assets/images/organisations/sports/varstvo-logo.png" alt="Varstvo Image" class="img-fluid">
  </div>

  <div class="container pt-5">
    <div class="row justify-content-center mt-4">
      <!-- Left Column (2 stacked squares) -->
      <div class="col-md-4 d-flex flex-column align-items-end align-items-md-start align-items-sm-center">
        <div class="square neon-red text-white mb-3">
          <p>KDAJ</p>
          <ul>
            <li>Od {{ varstvoStartDate | date:'dd.MM.yyyy' }} do {{ varstvoEndDate | date:'dd.MM.yyyy' }}</li>
            <li>Vsak dan od <strong>8:00 do 15:00</strong></li>
          </ul>
        </div>
        <div class="square neon-yellow text-white">
          <p>KJE</p>
          <ul>
            <li>Stara šola v Hotedršici</li>
            <li>Igrišče ob POŠ Hotedršica</li>
            <li>Okolica Hotedršice</li>
          </ul>
        </div>
      </div>
  
      <!-- Right Column (1 square) -->
      <div class="col-md-4 d-flex align-items-start align-items-md-start align-items-sm-center">
        <div class="square neon-purple text-white">
          <p>KAJ</p>
          <ul>
            <li>Vodne igre,</li>
            <li>gusarke igre,</li>
            <li>nočni kino,</li>
            <li>piknik,</li>
            <li>ekipne igre,</li>
            <li>nočne pustolovščine,</li>
            <li>športni turnirji,</li>
            <li>escape room,</li>
            <li>zabavne igre.</li>
          </ul>
        </div>
      </div>
    </div>

  
    <!-- Second Row (Centered single square) -->
    <div class="row justify-content-center mt-4">
      <div class="col-md-8 d-flex justify-content-center">
        <div class="square neon-green text-white">
          <p>PRISPEVEK</p>
          <ul>
            <li><strong>60€</strong>.</li>
            <li>V ceno je vključeno: varstvo, malica, topel obrok, pijača, animacija otrok, organiziranje dogodkov in spominsko darilo.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="container mt-5" style="border-top: 1px solid white; padding-top: 2rem;">
    <h2 class="text-warning p-4 text-center">Dodatne informacije</h2>
    <div class="row text-light event-description">
      <!-- Left Column: Event Information -->
      <div class="col-md-6" style="border-right: 1px solid white;">
        <ul class="list-unstyled">
          <li>Koordinatorki: <strong>Zala Pivk</strong>, 068-648-418</li>, <strong>Lara Leskovec</strong>, 041-503-252
          <li>Email: hotenjskisportniteden&#64;gmail.com</li>
          <li><strong>OMEJENO ŠTEVILO PRIJAVLJENIH DO ZAPOLNITVE MEST!</strong></li>
          <li>Prijava na dogodek je veljavna ob plačilu stroškov varstva.</li>
          <li>Plačilo se izvede z nakazilom.</li>
          <ul class="ms-4">
            <li><strong>TRR:</strong> {{ organisation?.IBAN }}</li>
            <li><strong>VAT:</strong> {{ organisation?.VATNumber }}</li>
            <li><strong>Davčna številka:</strong> {{ organisation?.taxNumber }}</li>
            <li><strong>Namen:</strong> Varstvo otrok + ime in priimek otroka</li>
            <li><strong>Naslov:</strong> {{ organisation?.address }}</li>
          </ul>
        </ul>
      </div>
  
      <!-- Right Column: Button -->
      <div class="col-md-6 d-flex justify-content-center align-items-center">
        <button class="button-prijava neon-yellow" (click)="onVarstvoPrijavaClicked(); scrollTo('varstvo-prijava')">Prijava</button>
      </div>
    </div>
  </div>
  

  <div class="container mt-5 mb-5">
    <gallery class="w-100" id="gallery" [objectFit]="'contain'" [loop]="true" [items]="varstvoImages" (thumbClick)="onThumbClick($event)"></gallery>
  </div>
  
  <section *ngIf="showVarstvoPrijava" id="varstvo-prijava" class="mt-5 mb-5">
    <div *ngIf="showVarstvoPrijava">
      <app-varstvo-prijava [isOrgAdmin]="isOrgAdmin"></app-varstvo-prijava>
    </div>
    <div class="d-flex align-items-center justify-content-center mt-3" *ngIf="showVarstvoPrijava">
      <button class="button-prijava neon-red" (click)="OnVarstvoZapriClicked(); scrollTo('varstvo')">Zapri</button>
    </div>
  </section>

</section>
 <div *ngIf="!cold50Exists" class="curvy-container"></div>

<div *ngIf="cold50Exists" class="cold50-background-block">
    <div class="curvy-container-inv-color-blue" style="margin-top: -48px;"></div>

    <section *ngIf="cold50Exists" id="cold50" class="anchor-section">
        <div class="d-flex justify-content-center mb-5">
            <img src="../../../assets/images/organisations/sports/cold50/cold50maks.svg" alt="Cold50 Logo" class="img-fluid cold50-logo">
        </div>
        <h1 class="fw-bold text-center" style="color: white;">V Hotedršici na tekaških progah ob prvem snegu.</h1>
        <h2 class="fw-bold text-center mt-2" style="color: white;">Točni datum organizator sporoči naknadno.</h2>

        <div class="d-flex justify-content-center flex-wrap gap-4 mt-4 pb-4 text-center">
          <div class="circle neon-navy text-white p-4 mb-3">
            <fa-icon class="fa-2x" [icon]="faRocket"></fa-icon>
            <p class="font-size-1.5">9:00</p>
          </div>
          <div class="circle neon-blue text-white p-4 mb-3">
            <fa-icon class="fa-2x" [icon]="faFlagCheckered"></fa-icon>
            <p>16:00</p>
          </div>
          <div class="circle neon-green text-white p-4 mb-3">
            <fa-icon class="fa-2x" [icon]="faRuler"></fa-icon>
            <p>2 km</p>
          </div>
          <div class="circle neon-red text-white p-4 mb-3">
            <fa-icon class="fa-2x" [icon]="faRuler"></fa-icon>
            <p>5 km</p>
          </div>
        </div>
      <div class="d-flex align-items-center justify-content-center mt-5">
        <button class="button-prijava neon-candy" (click)="onCold50PrijavaClicked(); scrollTo('cold50-prijava')">PRIJAVA</button>
      </div>

      <div class="container mt-5" style="border-top: 1px solid white; padding-top: 2rem;">
        <h2 class="mt-4 fw-bold text-center" style="color: white;">Informacije</h2>
        <div class="row text-light event-description">
          <div class="col-md-6" style="border-right: 1px solid white;">
            <ul class="list-unstyled">
              <li>Cilj: Preteči čim več krogov, skupno največ 50 km.</li>
              <li>S tekom lahko začnete kadarkoli med 9:00 in 16:00.</li>
              <li>Po končanem izzivu si ustvari svojo spominsko medaljo.</li>
              <li>Dolžina kroga 2 ali 5 km.</li>
              <li>Vzemi si pavzo kadar želiš.</li>
              <li>Udeležba je brezplačna, pobira se prostovoljne prispevke.</li>
            </ul>
          </div>
      
          <div class="col-md-6 d-flex justify-content-center align-items-center">
            <ul class="list-unstyled">
              <li>Deloval bo servis smuči (5 €).</li>
              <li>Potekali bodo tečaji teka na smučeh s strani ekipe <a href="https://www.mikisport.si" target="_blank">MikiSport</a>.</li>
              <li>Vabljeni tekmovalci, navijači in vsi, ki bi se radi prvič preizkusili v teku na smučeh.</li>
              <li>Na voljo bo okrepčilo in zabavni program.</li>
              <li>Točno določen datum prireditve boste po prijavi prejeli na e-pošto.</li>
              <li><a [routerLink]="[]" fragment="proge" style="color: white;">
                  <strong class="neon-green">Podrobnosti o progah</strong>
                </a>
              </li>
            </ul>
          </div>
        </div>
      <div class="d-flex align-items-center justify-content-center mt-5">
        <button class="button-prijava neon-candy" (click)="onCold50PrijavaClicked(); scrollTo('cold50-prijava')">PRIJAVA</button>
      </div>
      </div>
        <section *ngIf="showCold50prijava" id="cold50-prijava" class="mt-5 mb-5">
          <div *ngIf="showCold50prijava">
            <app-cold50-prijava [isOrgAdmin]="isOrgAdmin"></app-cold50-prijava>
          </div>
          <div class="d-flex align-items-center justify-content-center mt-3" *ngIf="showCold50prijava">
            <button class="button-prijava neon-red" (click)="OnCold50ZapriClicked(); scrollTo('cold50')">Zapri</button>
          </div>
      </section>
    </section>

    <div class="curvy-container"></div>
    
</div>

<section id="proge" style="padding-top: 3em; margin-bottom: -25px;" class="anchor-section">
  <h1 class="font-weight-bold club-name animated-title text-center">TEKAŠKE PROGE</h1>
  <app-proge [isAdmin]="isOrgAdmin || isSuperAdmin"></app-proge>
</section>

<section id="van-rental" class="anchor-section">
  <h1 class="font-weight-bold club-name animated-title text-center">NAJEM KOMBIJA</h1>
  <button class="button-74 mt-3" (click)="showVanRentalForm = !showVanRentalForm">
    {{ showVanRentalForm ? 'Skrij obrazec' : 'Rezerviraj kombi' }}
  </button>
  <div id="vanRental" *ngIf="showVanRentalForm" class="mt-4 p-4 border rounded shadow bg-light container">
    <h3>Rezervacija kombija</h3>
    <form (submit)="submitVanRental()">
      <div class="mb-3">
        <label for="name">Ime</label>
        <input type="text" id="name" class="form-control" [(ngModel)]="vanRental.name" name="name" required />
      </div>
      <div class="mb-3">
        <label for="email">Email</label>
        <input type="email" id="email" class="form-control" [(ngModel)]="vanRental.email" name="email" required />
      </div>
      <div class="mb-3">
        <label for="phone">Telefon</label>
        <input type="text" id="phone" class="form-control" [(ngModel)]="vanRental.phone" name="phone" required />
      </div>
      <div class="mb-3">
        <label for="date">Datum najema</label>
        <input type="date" id="date" class="form-control" [(ngModel)]="vanRental.startDate" name="date" required />
      </div>
      <div class="mb-3">
        <label for="duration">Datum zaključka</label>
        <input type="date" id="duration" class="form-control" [(ngModel)]="vanRental.endDate" name="duration" required />
      </div>
      <div class="mb-3">
        <label for="relation">Relacija</label>
        <input type="relation" id="relation" class="form-control" [(ngModel)]="vanRental.relation" name="relation" required />
      </div>
      <div class="mb-3">
        <label for="description">Opis najema</label>
        <textarea id="description" class="form-control" [(ngModel)]="vanRental.description" name="description" required></textarea>
      </div>
  
      <button type="submit" class="button-74">
        <span *ngIf="!isVanSending">Pošlji</span>
        <span *ngIf="isVanSending">
          <div class="spinner-border spinner-border-sm text-light" role="status"></div>
          Pošiljanje...
        </span>
      </button>
    </form>
  
    <button class="button-74 mt-3" (click)="showVanRentalForm = false">Zapri</button>
  </div>
</section>
<div class="curvy-container-inv"></div>

<section id="donations" class="p-2 anchor-section">
  <div class="container mt-5 mb-5">
    <div style="text-align:center; background-color:#e6f3ff; padding:25px; border-radius:20px; box-shadow:0 2px 10px rgba(0,0,0,0.1); max-width:650px; margin:auto;">      
      <h2 style="color:#005fa3; font-weight:700;">Podprite naše društvo z delom dohodnine </h2>
      
      <p style="font-size:17px; color:#222; line-height:1.6;">
        Vaš <strong>1 % dohodnine</strong> lahko pomaga <strong>Športnemu društvu Hotedršica</strong> pri organizaciji športnih dejavnosti,
        dogodkov in podpori mladih športnikov.<br>
        Donacija vas <strong>nič ne stane</strong>, nam pa pomeni <strong>veliko!</strong>
      </p>

      <div style="display: flex; justify-content: center; align-items: center; gap: 20px; margin-top: 15px;">
        
        <div style="background-color:#ffffff; border-radius:12px; padding:15px; box-shadow:0 1px 5px rgba(0,0,0,0.08); text-align: left;">
          Oddajte obrazec na <a href="https://edavki.durs.si" target="_blank" style="color:#005fa3; font-weight:600;">eDavki</a><br>
          in vpišite naše podatke:<br><br>
          <strong>Športno društvo Hotedršica</strong><br>
          Davčna številka: <strong>84478446</strong>
        </div>

        <img 
            src="/assets/images/organisations/sports/logo.png" 
            alt="Športno društvo Hotedršica" 
            style="width: 100px; height: auto; flex-shrink: 0;"
        />
      </div>

      <p style="color:#005fa3; margin-top:20px; font-weight:600; font-size:16px;">
        Hvala, ker z nami soustvarjate športno zgodbo naše skupnosti! 
      </p>
    </div>
  </div>
</section>
<div class="curvy-container"></div>

<!-- Club Details Section -->
<section id="club-details" class="club-details p-2 anchor-section">
  <h1 class="font-weight-bold club-name animated-title text-center mt-5">VIZITKA</h1>
  
  <div class="container mt-5 ">
    <div class="row g-4">
      <!-- Contact Information Card -->
      <div class="col-md-6">
        <div class="card shadow-lg border-0 h-100">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <fa-icon class="me-2" [icon]="faHouse" style="color: rgb(37, 150, 190);"></fa-icon>
              <h3 class="card-title mb-0">Kontaktni Podatki</h3>
            </div>
            <hr>
            <p class="fw-bold mb-1">{{organisation?.name}}</p>
            <p class="mb-2">
              <fa-icon class="me-2" [icon]="faHouse" style="color: rgb(37, 150, 190);"></fa-icon>
              {{organisation?.address}}, {{organisation?.postalCode}}
            </p>
            <p class="mb-2">
              <fa-icon class="me-2" [icon]="faEnvelope" style="color: rgb(37, 150, 190);"></fa-icon>
              {{organisation?.email}}
            </p>
            <p class="mb-2">
              <fa-icon class="me-2" [icon]="faPhone" style="color: rgb(37, 150, 190);"></fa-icon>
              {{organisation?.phone}}
            </p>
            <p class="mb-2"><strong>TRR:</strong> {{organisation?.IBAN}}</p>
            <p class="mb-2"><strong>Matična številka:</strong> {{organisation?.VATNumber}}</p>
            <p class="mb-2"><strong>Davčna številka:</strong> {{organisation?.taxNumber}}</p>
          </div>
        </div>
      </div>

      <!-- Join Us Card -->
      <div class="col-md-6">
        <div class="card shadow-lg border-0 h-100">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <fa-icon class="me-2" [icon]="faUserPlus" style="color: rgb(37, 150, 190);"></fa-icon>
              <h3 class="card-title mb-0">Pridruži se nam</h3>
            </div>
            <hr>
            <p>Če želite postati del naše skupnosti, izpolnite prijavnico in nam jo pošljite na naslov: 
              <strong>{{organisation?.address}}</strong> ali na e-pošto: 
              <strong>{{organisation?.email}}</strong>
            </p>
            <div class="d-flex justify-content-center gap-2">
              <button (click)="openJoinFile()" class="button-74">
                Prijavnica
              </button>
              <button (click)="openLeaveFile()" class="button-74">
                Izstopi iz društva
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="leaders" class="p-2 anchor-section">
  <h1 class="font-weight-bold club-name animated-title text-center">VODSTVO</h1>

  <div class="container mt-5">
    <div class="row justify-content-center align-items-center g-4">
      <!-- Leadership Card -->
      <div class="col-md-5 d-flex justify-content-center">
        <div class="card shadow-lg border-0 w-100">
          <div class="card-body">
            <h3 class="card-title mb-3">
              <fa-icon class="me-2" [icon]="faUserTie"></fa-icon> Vodstvo
            </h3>
            <hr>

            <!-- President & Vice President -->
            <div *ngIf="organisation?.leaders">
              <div *ngFor="let leader of organisation!.leaders">
                <div *ngIf="leader.role === 'Predsednik'">
                  <p><strong>Predsednik:</strong> {{ leader.name }} ({{ leader.phone }})</p>
                    <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn btn-danger" (click)="deleteLeader(leader.leaderID)">
                    <fa-icon  [icon]="faTrash"></fa-icon>
                    </button>
                </div>
                <div *ngIf="leader.role === 'Podpredsednik'">
                  <p><strong>Podpredsednik:</strong> {{ leader.name }} ({{ leader.phone }})</p>
                  <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn btn-danger" (click)="deleteLeader(leader.leaderID)"><fa-icon [icon]="faTrash"></fa-icon></button>
                </div>
              </div>
            </div>

            <!-- Upravni Odbor -->
            <h4 class="mt-4"><strong>Upravni odbor</strong></h4>
            <div *ngIf="organisation?.leaders">
              <div *ngFor="let leader of organisation!.leaders">
                <div *ngIf="['Član', 'Blagajnik', 'Tajnica'].includes(leader.role)">
                  {{ leader.name }} ({{ leader.role }})
                  <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn btn-danger" (click)="deleteLeader(leader.leaderID)">
                    <fa-icon [icon]="faTrash"></fa-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- Nadzorni Odbor -->
            <h4 class="mt-4"><strong>Nadzorni odbor</strong></h4>
            <div *ngIf="organisation?.leaders">
              <div *ngFor="let leader of organisation!.leaders">
                <div *ngIf="leader.role === 'Nadzorni odbor'">
                  {{ leader.name }}
                  <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn btn-danger" (click)="deleteLeader(leader.leaderID)">
                    <fa-icon [icon]="faTrash"></fa-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- Častno Razsodišče -->
            <h4 class="mt-4"><strong>Častno razsodišče</strong></h4>
            <div *ngIf="organisation?.leaders">
              <div *ngFor="let leader of organisation!.leaders">
                <div *ngIf="leader.role === 'Častno razsodišče'">
                  {{ leader.name }}
                  <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn btn-danger" (click)="deleteLeader(leader.leaderID)">
                    <fa-icon [icon]="faTrash"></fa-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Leadership Image -->
      <div class="col-md-5 d-flex justify-content-center">
        <img src="/assets/images/organisations/sports/vodstvo.jpg" alt="Leadership Image" class="img-fluid rounded shadow-lg">
      </div>
    </div>
  </div>
  <!-- Add Leader Section -->
<div *ngIf="isOrgAdmin || isSuperAdmin" id="add-leader" class="p-2">
  <h2 class="text-center font-weight-bold">Dodaj novega člana</h2>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <form (ngSubmit)="onSubmitAddLeader()">
          <div class="mb-3">
            <label for="leaderName" class="form-label">Ime in priimek</label>
            <input type="text" class="form-control" id="leaderName" [(ngModel)]="newLeader.name" name="name" required>
          </div>

            <div class="mb-3"></div>
            <label for="leaderRole" class="form-label">Vloga</label>
            <select class="form-control" id="leaderRole" [(ngModel)]="newLeader.role" name="role" required>
              <option value="Predsednik">Predsednik</option>
              <option value="Podpredsednik">Podpredsednik</option>
              <option value="Tajnica">Tajnica</option>
              <option value="Član">Član</option>
              <option value="Blagajnik">Blagajnik</option>
              <option value="Nadzorni odbor">Nadzorni odbor</option>
              <option value="Častno razsodišče">Častno razsodišče</option>
            </select>

          <div class="mb-3">
            <label for="leaderEmail" class="form-label">Email</label>
            <input type="email" class="form-control" id="leaderEmail" [(ngModel)]="newLeader.email" name="email" required>
          </div>

          <div class="mb-3">
            <label for="leaderPhone" class="form-label">Telefon</label>
            <input type="tel" class="form-control" id="leaderPhone" [(ngModel)]="newLeader.phone" name="phone" required>
          </div>

          <!--<div class="mb-3">
            <label for="leaderImage" class="form-label">Image URL</label>
            <input type="text" class="form-control" id="leaderImage" [(ngModel)]="newLeader.imageRef" name="imageRef">
          </div>-->

          <button type="submit" class="btn btn-primary">Dodaj</button>
        </form>
      </div>
    </div>
  </div>
</div>
<div *ngIf="organisationId" id="report-section" class="card shadow-lg border-0 h-100 mt-3 animated-text container">
  <app-report-list [orgID]="organisationId" [isAdmin]="isOrgAdmin || isSuperAdmin"></app-report-list>
</div>
</section>

<section id="sponsors" class="anchor-section">
  <h1 class="font-weight-bold club-name animated-title text-center">SPONZORJI</h1>
  <div class="container mt-5 d-flex justify-content-center">
      <div class="col-12 mb-4 text-center">
        <img src="../../../assets/images/organisations/sports/sponsors/SPONZORJI.jpg" alt="Sponsor 1" class="img-fluid">
      </div>
  </div>
</section>
<!--
  <section id="friendship-race">
    <h2>TEK PRIJATELJSTVA</h2>
    <p>Friendship race content goes here...</p>
  </section>
-->
